import { companyName } from 'config'
import { removeNonPagePermissions } from 'hooks/hasPagePermissions'
import Parties from 'pages/Loan/Parties'
import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PaymentOrderType } from 'services'
import { useTitle } from 'utils/pageTitle'

import { ApplicationEmailTemplate } from './ApplicationEmailTemplate'
import { BrokerAgreement } from './BrokerAgreement'
import { BrokerConditionCategories } from './BrokerConditionCategories'
import { BrokerEmails } from './BrokerEmails'
import { BrokerInvitationEmails } from './BrokerInvitationEmails'
import { BrokerTemplates } from './BrokerTemplates'
import { BrokerVerificationCategory } from './BrokerVerificationCategory/BrokerVerificationCategory'
import { ClosingCostTemplate } from './ClosingCostTemplate'
import { Conditions } from './Conditions'
import { EmailTemplates } from './EmailTemplates'
import { InvestorsServicers } from './InvestorsServicers'
import { LoanStructureConditions } from './LoanStructureConditions'
import { LoanTermSheet } from './LoanTermSheet'
import { Notes } from './Notes'
import { PaymentTypes } from './PaymentType'
import { ReviewFormItems } from './ReviewFormItems'
import { Rolodex } from './Rolodex'
import SurveyTemplates from './SurveyTemplates'
import { Tasks } from './Tasks'
import { UnderwriterTemplates } from './Templates'
import { UWConditionCategories } from './UWConditionCategories'
import { WarehouseLenders } from './WarehouseLenders'

type menuType = {
  [key: string]: string //fix this
}

const _leftMenuItems: menuType = {
  conditions: 'Conditions',
  underwriterTemplates: 'UW Condition Templates',
  uwConditionCategories: 'UW Condition Categories',
  brokerTemplates: 'Loan Setup Condition Templates',
  brokerConditionCategories: 'Loan Setup Condition Categories',
  loanStructureConditions: 'Loan Structure & Application Conditions',
  party: 'Parties',
  tasks: 'Tasks',
  notes: 'Notes',
  rolodex: 'Rolodex',
  reviewForm: 'Appraisal Review Conditions',
  investorsServicers: 'Investors & Servicers',
  emailTemplates: `Email Templates`,
  loanTermSheet: `Loan Term Sheet Template`,
  brokerAgreement: 'Third Party Agreement Template',
  brokerEmails: 'Third Party Email Template',
  brokerInvitationEmails: 'Broker Invitation Email Template',
  warehouseLender: 'Warehouse Lenders',
  invoicePaymentTypes: 'Invoice Fee Templates',
  surveyTemplate: 'Review Templates',
  applicationEmailTemplate: 'Loan Application Email Template',
  thridPartyApprovalCategory: 'Third party Approval Categories',
  closingCostTemplate: 'Closing Cost Template',
}

export default function ConditionsAndTemplates() {
  useTitle(`Conditions and Templates - ${companyName}`)

  const navigate = useHistory()
  const [selectedMenu, setSelectedMenu] = useState('')

  const setMenu = (menuItem: string) => {
    setSelectedMenu(menuItem)
    navigate.push(`/condition_template/${menuItem}`)
  }

  const renderFragment = useMemo(() => {
    switch (selectedMenu) {
      case 'conditions':
        return <Conditions />
      case 'underwriterTemplates':
        return <UnderwriterTemplates />
      case 'uwConditionCategories':
        return <UWConditionCategories />
      case 'brokerTemplates':
        return <BrokerTemplates />
      case 'brokerConditionCategories':
        return <BrokerConditionCategories />
      case 'loanStructureConditions':
        return <LoanStructureConditions />
      case 'tasks':
        return <Tasks />
      case 'notes':
        return <Notes />
      case 'rolodex':
        return <Rolodex />
      case 'reviewForm':
        return <ReviewFormItems />
      case 'investorsServicers':
        return <InvestorsServicers />
      case 'emailTemplates':
        return <EmailTemplates />
      case 'loanTermSheet':
        return <LoanTermSheet />
      case 'invoicePaymentTypes':
        return <PaymentTypes type={PaymentOrderType.LoanSubmissionRush} />
      case 'surveyTemplate':
        return <SurveyTemplates />
      case 'brokerAgreement':
        return <BrokerAgreement />
      case 'brokerEmails':
        return <BrokerEmails />
      case 'warehouseLender':
        return <WarehouseLenders />
      case 'party':
        return <Parties />
      case 'applicationEmailTemplate':
        return <ApplicationEmailTemplate />
      case 'brokerInvitationEmails':
        return <BrokerInvitationEmails />
      case 'thridPartyApprovalCategory':
        return <BrokerVerificationCategory />
      case 'closingCostTemplate':
        return <ClosingCostTemplate />
      default: {
        return <div>Comming Soon...</div>
      }
    }
  }, [selectedMenu])

  const leftMenuItems = useMemo(() => {
    removeNonPagePermissions(_leftMenuItems as any, ['condition_template'])
    return _leftMenuItems
  }, [])

  useEffect(() => {
    setMenu(Object.keys(leftMenuItems)[0])
  }, [])

  return (
    <div className="vendors-container py-6">
      <div className="vendors-wrapper max-w-screen-2xl m-auto grid grid-cols-12 gap-6 px-2">
        <div className="sidebar-left col-span-12 md:col-span-3 shrink-0 bg-white shadow1 rounded">
          <ul className="sidebar-items flex flex-col p-4 pb-20">
            {Object.keys(leftMenuItems).map((item: string, index) => {
              return (
                <li
                  key={index}
                  onClick={() => {
                    setMenu(item)
                  }}
                  className="border-b py-2"
                >
                  <p
                    className={`hover:underline cursor-pointer ${
                      selectedMenu === item ? 'border px-4 py-1 bg-zinc-100' : 'py-1'
                    }`}
                  >
                    {index + 1}. {leftMenuItems[item as keyof typeof leftMenuItems]}
                  </p>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="content-right col-span-12 md:col-span-9 bg-white p-4 rounded shadow1">{renderFragment}</div>
      </div>
    </div>
  )
}
